import { SidebarNavItem } from './sidebar-nav-item.model';

/**
 * Whether a sidebar item should show as active for the given router URL (ER-1542).
 *
 * The query string and fragment are ignored, because NavigationEnd.urlAfterRedirects and router.url both carry them.
 * An item with an activePrefix is active on that path and on every path below it, on a '/' boundary, so
 * '/manual-ops' lights '/manual-ops/communication' but not '/manual-ops-x'. Any other item is active only on its
 * exact routerLink.
 */
export function isNavItemActive(url: string, item: Pick<SidebarNavItem, 'routerLink' | 'activePrefix'>): boolean {
    const path = url.split(/[?#]/)[0];
    if (!path) {
        return false;
    }

    if (item.activePrefix) {
        return path === item.activePrefix || path.startsWith(item.activePrefix + '/');
    }

    return !!item.routerLink && path === item.routerLink;
}
